/**
 * Presentation & Services Section Animations
 * Animate elements on scroll with GSAP
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class PresentationAnimation {
  constructor() {
    this.initIntroImage();
    this.initPresentationImage();
    this.initServicesCards();
  }

  initIntroImage() {
    const image = document.querySelector('.intro-section__image');
    
    if (!image) {
      return;
    }

    gsap.to(image, {
      opacity: 1,
      x: 0,
      duration: 0.8,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: image,
        start: 'top 85%',
        once: true,
      },
      onComplete: () => {
        image.classList.add('animated');
      }
    });
  }

  initPresentationImage() {
    const image = document.querySelector('.presentation-section__image');
    
    if (!image) {
      return;
    }

    gsap.to(image, {
      opacity: 1,
      x: 0,
      duration: 0.8,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: image,
        start: 'top 85%',
        once: true,
      },
      onComplete: () => {
        image.classList.add('animated');
      }
    });
  }

  initServicesCards() {
    const cards = document.querySelectorAll('.service-card');
    
    if (!cards.length) {
      return;
    }

    cards.forEach((card, index) => {
      gsap.to(card, {
        opacity: 1,
        y: 0,
        duration: 0.6,
        delay: index * 0.15,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: card,
          start: 'top 90%',
          once: true,
        },
        onComplete: () => {
          card.classList.add('animated');
        }
      });
    });
  }
}
